import { mapState } from 'vuex';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      showChannel: state => state.showChannel
    }),
    showSwitchVersion() {
      return [175].includes(+this.gameId) && !this.showChannel;
    }
  },
  methods: {
    switchVersion() {
      window.location.href = getGlobalGetGotoLink({
        link: window.location.href
          .replace('officialWebStore.html', 'officialTopupNew.html')
          .replace(window.location.hash, '#/')
      });
    }
  }
};
